import * as THREE from 'three'

import MathsUtils from '@/utils/mathsUtils'
import BaseObject from './baseObject'
import NineSliceMesh from '../library/three/NineSliceMesh'

import { Text } from 'troika-three-text'


// Shape Title Object
// Used to show details (stock, mark, number) info under a GlassShape
export default class ShapeTitleObject extends BaseObject {
  constructor(editor, options = {}) {
    super(editor)

    this.persistable = false
    this.bgTexture = editor.resources.titleBarBG

    this.position = new THREE.Vector2(0, 0)
    this.mouseHover = false

    this.backgroundObject = null;
    this.labelTextObj = null;
    this.labelIndexObj = null;
    
    this.listenMouseEvents = false

    this.info = {
      shapeIndex: 0,
      quantity: 1,
      stockCode: '',
      stockName: '',
      priceGroupName: '',
      mark: ''
    }

    this.sceneObject = new THREE.Object3D()
    this.updateSceneObject()
  }

  // Dispose
  dispose() {
    super.dispose()

    this.backgroundObject = null
  }

  // onBeforeRender
  // Called prior to rendering of the object
  onBeforeRender() {
    super.onBeforeRender()

    var positionZ = 250
    var displayScale = 1.0 / this.editor.camera.zoom
    displayScale = Math.min(displayScale, 3.0)

    if(this.backgroundObject) {     
      this.backgroundObject.position.set(this.position.x, this.position.y, positionZ)
      this.backgroundObject.scale.set(displayScale, -displayScale, 1)     // Flipped to adjust for texture
    }
    if(this.labelTextObj && this.backgroundObject) {
      var paddingLeft = 55.0
      var paddingTop = 8.0
      var labelPosX = this.position.x - (this.backgroundObject.getWidth() * 0.5 - paddingLeft) * displayScale
      var labelPosY = this.position.y - (this.backgroundObject.getHeight() * 0.5 - paddingTop) * displayScale

      this.labelTextObj.position.set(labelPosX, labelPosY, positionZ + 10)
      this.labelTextObj.scale.set(displayScale, -displayScale, 1)     // Flipped to adjust for texture
    }

    if(this.labelIndexObj && this.backgroundObject) {
      var paddingLeft = 8.0
      var paddingTop = 0.0
      var labelPosX = this.position.x - (this.backgroundObject.getWidth() * 0.5 - paddingLeft) * displayScale
      var labelPosY = this.position.y - 5 * displayScale// - (this.backgroundObject.getHeight() * 0.5 - paddingTop) * displayScale

      this.labelIndexObj.position.set(labelPosX, labelPosY, positionZ + 10)
      this.labelIndexObj.scale.set(displayScale, -displayScale, 1)     // Flipped to adjust for texture
    }
  }


  // Update the position of the icon
  setPosition(pos) {
    this.position.set(pos.x, pos.y)
  }

  // Update the rotation of the icon
  // Set in degrees
  setRotation(angle) {
    this.angle = angle
  }


  /**
   * Build the initial drawing objects to display the editing line
   */
  updateSceneObject() {
    this.clearSceneObject()

    this.backgroundObject = new NineSliceMesh(this.bgTexture, {
      width: 420,
      height: 70,
      textureWidth: 128,
      textureHeight: 64,
      left: 32,
      right: 32,
      top: 32,
      bottom: 32
    })

    this.backgroundObject.position.set(this.position.x, this.position.y, 0)
    this.backgroundObject.scale.y = -1    // Flip around for the texture adjustment
    this.sceneObject.add(this.backgroundObject)

    this.labelTextObj = new Text()
    this.labelTextObj.text = `${this.info.quantity}x ${this.info.stockCode} - ${this.info.stockName}\n${this.info.priceGroupName}\n${this.info.mark}`
    this.labelTextObj.position.set(this.position.x, this.position.y, 0)
    this.labelTextObj.color = '#404040'
    this.labelTextObj.fontSize = 13
    this.labelTextObj.lineHeight = 1.25
    this.labelTextObj.anchorX = 'left'
    this.labelTextObj.anchorY = 'top'
    this.sceneObject.add(this.labelTextObj)

    this.labelTextObj.addEventListener('synccomplete', () => {
      this.editor.flagRenderRequired()
    })

    this.labelIndexObj = new Text()
    this.labelIndexObj.text = `#${this.info.shapeIndex + 1}`
    this.labelIndexObj.fontWeight = 'bold'
    this.labelIndexObj.position.set(this.position.x, this.position.y, 0)
    this.labelIndexObj.color = '#A0A0A0'
    this.labelIndexObj.fontSize = 22
    this.labelIndexObj.anchorX = 'left'
    this.labelIndexObj.anchorY = 'middle'
    this.sceneObject.add(this.labelIndexObj)

    this.labelIndexObj.addEventListener('synccomplete', () => {
      this.editor.flagRenderRequired()
    })
  }

  updateTitleDetails(index, quantity, stockCode, stockName, priceGroupName, mark) {
    this.info.shapeIndex = index
    this.info.quantity = quantity
    this.info.stockCode = stockCode
    this.info.stockName = stockName
    this.info.priceGroupName = priceGroupName
    this.info.mark = mark

    if(this.labelTextObj) {
      this.labelTextObj.text = `${this.info.quantity}x ${this.info.stockCode} - ${this.info.stockName}\n${this.info.priceGroupName}\n${this.info.mark}`
    }
    if(this.labelIndexObj) {
      this.labelIndexObj.text = `#${this.info.shapeIndex + 1}`
    }
  }
}
